import React, { useEffect, useState, useCallback } from "react";
import { useParams, Outlet } from "react-router-dom";
import { api } from "@/lib/api";
import { SnapProvider } from "@/lib/AppContext";
import Sidebar from "@/components/Sidebar";

export default function SnapshotLayout() {
  const { sid } = useParams();
  const [snapshot, setSnapshot] = useState(null);
  const [error, setError] = useState(false);

  const reload = useCallback(async () => {
    try {
      const r = await api.get(`/snapshots/${sid}`);
      setSnapshot(r.data);
    } catch (e) {
      setError(true);
    }
  }, [sid]);

  useEffect(() => { setSnapshot(null); setError(false); reload(); }, [reload]);

  return (
    <SnapProvider value={{ snapshot, reload }}>
      <div className="flex min-h-screen bg-stone-100 text-stone-900">
        <Sidebar />
        <main className="flex-1 min-w-0">
          {error ? (
            <div className="p-10 text-rose-600">Snapshot not found.</div>
          ) : !snapshot ? (
            <div className="p-10 text-stone-400">Loading snapshot…</div>
          ) : (
            <Outlet />
          )}
        </main>
      </div>
    </SnapProvider>
  );
}
